import { render, staticRenderFns } from "./DocText.vue?vue&type=template&id=e2df2a5a&scoped=true&"
import script from "./DocText.vue?vue&type=script&lang=js&"
export * from "./DocText.vue?vue&type=script&lang=js&"
import style0 from "./DocText.vue?vue&type=style&index=0&id=e2df2a5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2df2a5a",
  null
  
)

export default component.exports